<template>
    <div id="app">
        <div class="page" id="paopaotui-page" v-if="!isLaunch">
            <div class="page-content" :class="{iphone: isIPhone}" ref="pageContent">
                <div v-if="$route.meta.noDrive">
                    <no-drive/>
                    <div style="height: 10vh"/>
                </div>
                <order-status ref="orderStatus"/>
                <keep-alive>
                    <router-view v-if="$route.meta.keepAlive"></router-view>
                </keep-alive>
                <router-view v-if=" ! $route.meta.keepAlive"></router-view>
                <fab/>
            </div>
        </div>
        <div class="info" v-show="!isLaunch && !isLineMini">
            <div class="row">
                <div class="item">
                    <div class="img">
                        <img src="@/assets/img/home/home1.png">
                    </div>
                    <div class="title">
                        配對一位即時人力
                    </div>
                    <div class="content">
                        馬上讓騎士完成您交辦的事
                    </div>
                </div>
                <div class="item">
                    <div class="img">
                        <img src="@/assets/img/home/home2.png">
                    </div>
                    <div class="title">
                        輕鬆省下時間
                    </div>
                    <div class="content">
                        幫您跑腿讓您不再勞碌
                    </div>
                </div>
                <div class="item">
                    <div class="img">
                        <img class="logo" src="@/assets/img/home/home3.png">
                    </div>
                    <div class="title">
                        萬能的服務
                    </div>
                    <div class="content">
                        解決您生活上遇到的任何困難
                    </div>
                </div>
            </div>
            <div class="row">
                <div class="item">
                    <div class="img">
                        <img class="logo" src="@/assets/img/home/qr-line.png">
                    </div>
                    <div class="title">
                        加入 LINE 可即時收到任務推播
                    </div>
                </div>
                <div class="item">
                    <div class="img">
                        <img class="logo" src="@/assets/img/home/qr-fb.png">
                    </div>
                    <div class="title">
                        FB 粉絲專頁
                    </div>
                </div>
            </div>
        </div>
        <launch v-show="isLaunch"/>
        <step-by-step v-if="isStepByStep" @onStart="stepDone = true"/>
        <unrated-order ref="unrated"/>
        <has-gift-modal ref="hasGiftModal"/>
        <div class="activities" v-if="!isLaunch && showActivities">
            <pop-activity v-for="activity in filterActivities" :activity="activity" :key="activity.id"/>
        </div>
    </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex';
import Launch from './views/components/Launch';
import Swal from 'sweetalert2';
import moment from 'moment';
import * as apis from './apis';
import StepByStep from './views/components/StepByStep';
import OrderStatus from './views/components/order/OrderStatus';
import NoDrive from "./views/components/NoDrive";
import UnratedOrderModal from "./views/components/modal/UnratedOrderModal";
import HasRecommendGiftModal from "./views/components/modal/HasRecommendGiftModal";
import FloatingActionButton from "./views/components/FloatingActionButton";
import PopActivity from "./views/components/PopActivity";

export default {
    name: 'app',
    metaInfo: {
        title: '跑跑腿',
        meta: [
            {vmid: 'description', name: 'description', content: '最靈活的生活服務平台，提供隨心所欲的跑腿服務！代買代購代排隊，不用出門就能幫您外送到家，不限店家、距離或金額。一單多點服務，省下寶貴時間，生活享受不只一點，呼叫騎士為您即刻出發！'},
            {vmid: 'og:title', property: 'og:title', content: '跑跑腿'},
            {vmid: 'og:description', property: 'og:description', content: '最靈活的生活服務平台，提供隨心所欲的跑腿服務！代買代購代排隊，不用出門就能幫您外送到家，不限店家、距離或金額。一單多點服務，省下寶貴時間，生活享受不只一點，呼叫騎士為您即刻出發！'},
            {vmid: 'robots', name: 'robots', content: 'all'}
        ]
    },
    components: {
        'launch': Launch,
        'step-by-step': StepByStep,
        'order-status': OrderStatus,
        'no-drive': NoDrive,
        'unrated-order': UnratedOrderModal,
        'has-gift-modal': HasRecommendGiftModal,
        'fab': FloatingActionButton,
        'pop-activity': PopActivity,
    },
    data() {
        return {
            isLoaded: false,
            isEndTime: false,
            setTime: null,
            interval: null,
            notice: 0,
            stepDone: false,
            initEchoed: false,
            reloadEvent: new Event('reloadEvent'),
            showActivities: true,
        }
    },
    computed: {
        isLaunch: {
            get() {
                return this.getIsLaunch;
            },
            set(val) {
                this.setIsLaunch(val);
            },
        },
        isIPhone() {
            return !!navigator.platform && /iPad|iPhone|iPod/.test(navigator.platform);
        },
        isStepByStep() {
            return !this.isLaunch && !this.stepDone;
        },
        filterActivities() {
            let closeActivities = localStorage.getItem('close-activities');
            if (closeActivities) {
                closeActivities = JSON.parse(closeActivities);
            } else {
                closeActivities = [];
            }
            return this.activities.filter(function(activity) {
                let index = closeActivities.findIndex(function(ca) {
                    return ca.id == activity.id;
                })
                return index < 0;
            });
        },
        ...mapGetters(['logging', 'user', 'cartId', 'getIsLaunch', 'isLineMini', 'messages', 'activities'])
    },
    methods: {
        init() {
            this.isLaunch = true;

            this.setTime = setTimeout(() => {
                this.isEndTime = true;
                this.checkLaunch();
            }, 1000);

            let ApiRequests = [
                this.getAds(),
                this.getActivities(),
                this.getShops(),
                this.getMenus(),
            ];

            if (localStorage.getItem('token')) {
                ApiRequests = ApiRequests.concat([this.getMe(), this.getAgreements(), this.getProcessingOrders({}), this.getDriverIds(), this.getUnreadMessages(), this.getBlockIds()])
            }

            Promise.all(ApiRequests).then(() => {
                this.isLoaded = true;
                this.checkLaunch();

                if (localStorage.getItem('token')) {
                    this.initEcho();
                    this.checkUser();
                    this.getUnreadNotice();
                    this.showUnratedOrder();
                }
                this.getFcmToken();
            })
        },
        initEcho() {
            this.$echo.connector.pusher.connection.bind('state_change', (states) => {
                if (this.initEchoed) {
                    this.setSocketState(states.current);
                }

                if (this.initEchoed && states.current === 'connected' && this.$route.meta.isReloadOrder) {
                    this.getOrder(this.$route.params.id);
                }

                if (!this.initEchoed && states.current === 'connected') {
                    this.initEchoed = true;
                }
            });
            this.$echo.private(`App.Customer.User.${this.user.id}`)
                .listen('OrderStatusChanged', e => this.OrderStatusChanged(e))
                .listen('LocationArrived', e => this.loadOrder(e))
                .listen('LocationLeft', e => this.loadOrder(e))
                .listen('OrderDone', e => this.loadOrder(e))
                .listen('OrderPaid', e => this.loadOrder(e))
                .listen('OrderEstimatedTimeChanged', e => this.loadOrder(e))
                .listen('OrderTransferred', e => this.transferOrder(e))
                .listen('NewMessage', e => this.newMessage(e))
                .listen('ReadOrderMessages', e => this.ReadOrderMessages(e))
        },
        ReadOrderMessages(event) {
            if (this.$route.name == 'message' && this.$route.params.id == event.order_id) {
                let now = moment().toISOString();
                let readMessages = this.messages.map(message => {
                   message.read_at = now;
                   return message;
                });
                this.setMessages(readMessages);
            }
        },
        newMessage(event) {
            if (this.$route.name == 'message' && this.$route.params.id == event.messageable_id) {
                apis.getMessage(event.id).then(res => {
                    this.setMessages([res.data].concat(this.messages));
                    this.getUnreadMessages();
                });
            } else {
                this.getUnreadMessages();
            }
        },
        getFcmToken() {
            if (window.fetchToken && window.fetchToken.postMessage) {
                window.fetchToken.postMessage('setFcmToken');
            }

            if (window.flutter_inappwebview) {
                window.flutter_inappwebview.callHandler('fetchToken', 'setFcmToken');
            }
        },
        transferOrder(event) {
            if (!event.hasOwnProperty('old_order_id') || !event.hasOwnProperty('new_order_id')) {
                return;
            }

            if (this.$route.meta.isReloadOrder && this.$route.params.id == event.old_order_id) {
               this.$router.replace({
                   name: 'timeline',
                   params: {
                       id: event.new_order_id,
                   },
                   query: {
                       transfer: 1,
                   }
               })
            }
        },
        OrderStatusChanged(event) {
            if (!event.hasOwnProperty('order_id')) {
                return;
            }

            this.getOrder(event.order_id).then(res => {
                if (event.from === 'processing' && ['done', 'revoke', 'cancel'].includes(event.to)) {
                    setTimeout(() => {
                        this.$nextTick(() => {
                            if (this.$route.name !== 'orderCancel') {
                                this.$router.push({
                                    name: 'score',
                                    params: {
                                        id: res.data.id,
                                    }
                                });
                            }
                        });
                    }, 1000);
                }
            });
        },
        loadOrder(event) {
            if (event.hasOwnProperty('order_id')) {
                this.getOrder(event.order_id);
            }
        },
        checkLaunch() {
            this.isLaunch = ! (this.isLoaded && this.isEndTime);
        },
        checkUser() {
            if (! this.user.name) {
                this.$router.replace({name: 'register', query: { ic: this.$route.query.ic }});
            }
        },
        verifyTime() {
            apis.verifyTime(moment().format()).then(res => {
                if (! res.data.verified) {
                    Swal.fire({
                        type: 'warning',
                        title: '您的裝置時間不正確',
                        text: '請前往設定內修正時間，如不修正將會影響功能使用',
                    });
                }
            });
        },
        updateUnreadCount() {
            this.notice++;
            if (this.notice >= 6) {
                this.notice = 0;
                this.getUnreadNotice();
            }
        },
        appHeight() {
            document.documentElement.style.setProperty('--app-height', `${window.innerHeight}px`);
            setTimeout(() => {
                document.documentElement.style.setProperty('--app-height', `${window.innerHeight}px`);
            }, 500);
        },
        showUnratedOrder() {
            apis.unrated().then(res => {
                let orders = res.data;
                if (!orders.length) {
                    return false;
                }

                if (orders.length === 1) {
                    this.$router.push({
                        name: 'score',
                        params: {
                            id: orders[0].id,
                        }
                    });
                    return false;
                }

                setTimeout(() => {
                    this.$refs.unrated.show(orders);
                }, 2000);
            });
        },
        getUnreadNotice() {
            this.getUnreadNoticeCount().then(res => {
                if (res.data.has_gift) {
                    this.$refs.hasGiftModal.show();
                }
            });
        },
        ...mapActions(['getMe', 'getAds', 'getActivities', 'getShops', 'getAgreements', 'getProcessingOrders', 'clearCart', 'getSystemParameter', 'setCanOrder', 'getOrder', 'getMenus', 'setIsLaunch', 'getUnreadNoticeCount', 'setSocketState', 'getDriverIds', 'setMessages', 'getUnreadMessages', 'getBlockIds'])
    },
    created() {
        let urlParams = new URLSearchParams(window.location.search);
        let statusParams = urlParams.get('status');
        if (statusParams === 'ok' || statusParams === 'no')
            this.showActivities = false;

        window.addEventListener('resize', this.appHeight);
        this.appHeight();
        this.getSystemParameter();
        this.$echo.channel('system.parameters')
            .listen('WorkStatusChanged', () => this.getSystemParameter())
            .listen('SystemParameterChanged', () => this.getSystemParameter());

        this.verifyTime();
        this.interval = setInterval(() => {
            this.setCanOrder();

            if (localStorage.getItem('token')) {
                this.updateUnreadCount();
            }
        }, 5000);
        this.stepDone = localStorage.getItem('step-done');
        window.setFcmToken = (token) => {
            if (token) {
                localStorage.setItem('registration_token', token);
                if (localStorage.getItem('token')) {
                    apis.setDevice({
                        registration_token: token,
                        platform: 'web',
                        version: '1.0.0',
                        debug: JSON.stringify({
                            user_agent: navigator.userAgent
                        })
                    });
                } else {
                    apis.setAnonymityDevice({
                        registration_token: token,
                        platform: 'web',
                        version: '1.0.0',
                        debug: JSON.stringify({
                            user_agent: navigator.userAgent
                        })
                    });
                }
            }
        };
        window.reloadOrderData = () => {
            if (localStorage.getItem('token')) {
                this.getProcessingOrders({}).then(() => {
                    if (this.$route.meta.isReloadOrder) {
                        this.getOrder(this.$route.params.id);
                    }
                });
                this.getUnreadNotice();
                this.getUnreadMessages();
            }
            if (this.reloadEvent) {
                document.dispatchEvent(this.reloadEvent);
            }
        };
    },
    mounted() {
        this.init();
    },
    beforeDestroy() {
        this.$echo.leave(`App.Customer.User.${this.user.id}`);
        this.$echo.leave('system.parameters');
        window.removeEventListener('resize', this.appHeight);
    },
    destroyed() {
        clearTimeout(this.setTime);
        clearInterval(this.interval);
    },
    watch: {
        logging() {
            if (localStorage.getItem('token')) {
                Promise.all([
                    this.getMe(),
                    this.getAds(),
                    this.getShops(),
                    this.getAgreements(),
                    this.getProcessingOrders({}),
                    this.getMenus(),
                    this.getDriverIds(),
                    this.getBlockIds(),
                    this.getUnreadMessages(),
                ]).then(() => {
                    this.initEcho();
                    this.checkUser();
                    this.getUnreadNotice();
                    this.getFcmToken();
                    this.showUnratedOrder();
                })
            }
        }
    }
}
</script>

<style scoped>
    .page-content {
        background-color: #fff;
        width: inherit;
        min-height: var(--app-height);
        display: flex;
        flex-direction: column;
        position: relative;
    }

    .page-content.iphone {
        padding-top: constant(safe-area-inset-top);
        padding-bottom: constant(safe-area-inset-bottom);
        padding-top: env(safe-area-inset-top);
        padding-bottom: env(safe-area-inset-bottom, 34px);
    }

    .info {
        display: flex;
        flex: 1;
        justify-content: space-evenly;
        flex-direction: column;
        overflow: auto;
    }

    .info > .row {
        display: flex;
        align-items: baseline;
        justify-content: space-around;
        width: 100%;
    }

    .info > .row > .item > .img > img {
        width: 320px;
        height: auto;
    }

    .info > .row > .item > .img > .logo {
        width: 120px;
        height: auto;
    }

    .item > .title {
        font-size: 24px;
        font-weight: 500;
        line-height: 48px;
    }

    .item > .content {
        color: #808080;
    }

    @media screen and (max-width: 767px) {
        .info {
            display: none;
        }
    }

    @media screen and (min-width: 768px) and (max-width: 991px) {
        .info {
            display: none;
        }
    }

    @media screen and (max-width: 1413px) {
        .row {
            flex-direction: column;
            align-items: center !important;
        }

        .item {
            margin: 20px 0;
        }

        .info {
            display: unset;
            justify-content: flex-start;
        }
    }
</style>

<style>
    body {
        background-color: #F0F0F0;
        font-family: 'Noto Sans TC', sans-serif;
    }

    html, body, #app, .page, .launch{
        height: var(--app-height);
        width: 100%;
        padding: 0;
        margin: 0;
    }

    .page {
        max-width: 500px;
        background-color: #fff;
    }

    div {
        -ms-overflow-style: none;  /* IE and Edge */
        scrollbar-width: none;  /* Firefox */
    }

    /* Hide scrollbar for Chrome, Safari and Opera */
    div::-webkit-scrollbar {
        display: none;
    }

    #app {
        -webkit-font-smoothing: antialiased;
        -moz-osx-font-smoothing: grayscale;
        text-align: center;
        display: flex;
        justify-content: center;
    }

    .swal2-popup {
        font-size: 12px;
    }

    input:focus,
    select:focus,
    textarea:focus,
    button:focus {
        outline: none;
    }

    input,
    textarea,
    select:focus {
        font-size: 16px !important;
    }

    @media screen and (max-width: 767px) {
        .page {
            width: 100%;
            margin: 0 auto;
        }

        .paopaotui-sheet {
            width: 100% !important;
            margin: 0 auto;
        }
    }

    @media screen and (min-width: 768px) and (max-width: 991px) {
        .page {
            width: 500px;
            margin: 0 auto;
        }

        .paopaotui-sheet {
            width: 500px !important;
            margin: 0 auto;
        }
    }

    @media screen and (min-width: 992px) and (max-width: 1199px) {
        .page {
            width: 500px;
        }

        .paopaotui-sheet {
            width: 500px !important;
        }
    }

    @media screen and (min-width: 1200px) {
        .page {
            width: 500px;
        }

        .paopaotui-sheet {
            width: 500px !important;
        }
    }
</style>
